
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '@/actions';
import * as apis from '@/apis/eform';
import { E_FORM_GENERATION_REQUEST, EFORM_DOWNLOAD_REQUEST } from '@/actions/eform/actionTypes';

function* getEFormGenerationStatus() {
  try {
    const result = yield call(apis.getEFormGenerationStatus);
    yield put(actions.getEFormGenerationStatus.success(result.data));
  } catch (error) {
    yield put(actions.getEFormGenerationStatus.failure(error));
  }
}

function* eFormDownload({ payload, callback }: any) {
  try {
    const result = yield call(apis.eFormDownload, payload);
    callback(result.data)
    yield put(actions.eFormDownload.success(result.data));
  } catch (error) {
    yield put(actions.eFormDownload.failure(error));
  }
}

export default function* eformsagas() {
  yield takeLatest(E_FORM_GENERATION_REQUEST, getEFormGenerationStatus);
  yield takeLatest(EFORM_DOWNLOAD_REQUEST, eFormDownload);
}